/**
 * Basepaths Component
 */

import React, { FC } from 'react';
import { withTheme } from 'styled-components';

import Base from './base';
import { BasepathsProps } from './basepaths.types';
import { StyledBaseSVG } from './basepaths.style';
import {
  homeBase,
  firstBase,
  secondBase,
  thirdBase,
  defaultBaseLabels,
} from './constants';
import COLORS from '../../style/universal.color';


const retrievefilledColor = (
  filledColor: string | undefined
): string => {
  return filledColor || COLORS.outsYellow;
}

const retrieveStrokeColor = (
  strokeColor: string | undefined,
  isDarkMode: boolean | undefined
): string => {

  if (strokeColor) {

    return strokeColor;

  }

  return isDarkMode ? COLORS.mlbGrey2 : COLORS.mlbGrey3;
};

const retrieveEmptyColor = (
  emptyColor: string | undefined,
  isDarkMode: boolean | undefined,
): string => {

  if (emptyColor) {

    return emptyColor;

  }

  return isDarkMode ? COLORS.mlbGrey7 : COLORS.mlbGrey4;
};

const Basepaths: FC<BasepathsProps> = ({
  home,
  first,
  second,
  third,
  width = 30,
  altText = 'Bases.',
  theme = {},
  filledColor,
  strokeColor,
  emptyColor,
  strokeWidth = 1,
  handlers = {},
  showHome = false,
  enableHomeEvents = false,
  className,
  baseLabels = defaultBaseLabels,
}: BasepathsProps) => {
  // Set the viewbox to fit tightly around the bases
  const viewBox: string = showHome ? `0 0 24 23` : `0 0 24 16.25`;

  const {
    dark
  } = theme;

  const commonProps = {
    filledColor: retrievefilledColor(filledColor),
    emptyColor: retrieveEmptyColor(emptyColor, dark),
    strokeColor: retrieveStrokeColor(strokeColor, dark),
    strokeWidth,
    handlers,
    baseLabels,
  };

  const hasEvents = Object.keys(handlers).length > 0;

  return (
    <StyledBaseSVG
      className={ className }
      width={ width }
      role={ hasEvents ? undefined : 'img' }
      xmlns="http://www.w3.org/2000/svg"
      viewBox={ viewBox }
      {...hasEvents && { tabIndex: -1 }}
      aria-label={altText || 'base'}>
        <title>{ altText }</title>
        <Base filled={ !!third } transform={ 'translate(5, 7.25) rotate(-315)' } baseValue={ thirdBase } { ...commonProps } />
        <Base filled={ !!second } transform={ 'translate(12, 0.5) rotate(-315)' } baseValue={ secondBase } { ...commonProps } />
        <Base filled={ !!first } transform={ 'translate(19, 7.25) rotate(-315)' } baseValue={ firstBase } { ...commonProps } />
        {showHome && <Base filled={ !!home } transform={ 'translate(12, 14) rotate(-315)' } baseValue={ homeBase } eventsEnabled={ enableHomeEvents } { ...commonProps } />}
    </StyledBaseSVG>
  );
};

export default withTheme(Basepaths);
